/*
  countries.js (utility data)
  --------------------------------------------------
  Provides a mapping of country codes to:
    • Country name in English.
    • URL to country flag image (hosted via flagcdn).
  Used for:
    • Displaying guest nationality with flag and tooltip in GuestBookCard.vue.
    • Autocomplete suggestions and formatting in GuestModal.vue.
    • Nationality-based charts in ArchiveChart.vue.
*/
export const countries = {
  AFG: { name: "Afghanistan", flag: "https://flagcdn.com/w80/af.png" },
  ALB: { name: "Albania", flag: "https://flagcdn.com/w80/al.png" },
  DZA: { name: "Algeria", flag: "https://flagcdn.com/w80/dz.png" },
  AND: { name: "Andorra", flag: "https://flagcdn.com/w80/ad.png" },
  AGO: { name: "Angola", flag: "https://flagcdn.com/w80/ao.png" },
  ATG: { name: "Antigua and Barbuda", flag: "https://flagcdn.com/w80/ag.png" },
  ARG: { name: "Argentina", flag: "https://flagcdn.com/w80/ar.png" },
  ARM: { name: "Armenia", flag: "https://flagcdn.com/w80/am.png" },
  ABW: { name: "Aruba", flag: "https://flagcdn.com/w80/aw.png" },
  AUS: { name: "Australia", flag: "https://flagcdn.com/w80/au.png" },
  AUT: { name: "Austria", flag: "https://flagcdn.com/w80/at.png" },
  AZE: { name: "Azerbaijan", flag: "https://flagcdn.com/w80/az.png" },
  BHS: { name: "Bahamas", flag: "https://flagcdn.com/w80/bs.png" },
  BHR: { name: "Bahrain", flag: "https://flagcdn.com/w80/bh.png" },
  BGD: { name: "Bangladesh", flag: "https://flagcdn.com/w80/bd.png" },
  BRB: { name: "Barbados", flag: "https://flagcdn.com/w80/bb.png" },
  BLR: { name: "Belarus", flag: "https://flagcdn.com/w80/by.png" },
  BEL: { name: "Belgium", flag: "https://flagcdn.com/w80/be.png" },
  BLZ: { name: "Belize", flag: "https://flagcdn.com/w80/bz.png" },
  BEN: { name: "Benin", flag: "https://flagcdn.com/w80/bj.png" },
  BTN: { name: "Bhutan", flag: "https://flagcdn.com/w80/bt.png" },
  BOL: { name: "Bolivia", flag: "https://flagcdn.com/w80/bo.png" },
  BIH: {
    name: "Bosnia and Herzegovina",
    flag: "https://flagcdn.com/w80/ba.png",
  },
  BWA: { name: "Botswana", flag: "https://flagcdn.com/w80/bw.png" },
  BRA: { name: "Brazil", flag: "https://flagcdn.com/w80/br.png" },
  BRN: { name: "Brunei Darussalam", flag: "https://flagcdn.com/w80/bn.png" },
  BGR: { name: "Bulgaria", flag: "https://flagcdn.com/w80/bg.png" },
  BFA: { name: "Burkina Faso", flag: "https://flagcdn.com/w80/bf.png" },
  BDI: { name: "Burundi", flag: "https://flagcdn.com/w80/bi.png" },
  CPV: { name: "Cabo Verde", flag: "https://flagcdn.com/w80/cv.png" },
  KHM: { name: "Cambodia", flag: "https://flagcdn.com/w80/kh.png" },
  CMR: { name: "Cameroon", flag: "https://flagcdn.com/w80/cm.png" },
  CAN: { name: "Canada", flag: "https://flagcdn.com/w80/ca.png" },
  CYM: { name: "Cayman Islands", flag: "https://flagcdn.com/w80/ky.png" },
  CHL: { name: "Chile", flag: "https://flagcdn.com/w80/cl.png" },
  CHN: { name: "China", flag: "https://flagcdn.com/w80/cn.png" },
  COL: { name: "Colombia", flag: "https://flagcdn.com/w80/co.png" },
  CRI: { name: "Costa Rica", flag: "https://flagcdn.com/w80/cr.png" },
  HRV: { name: "Croatia", flag: "https://flagcdn.com/w80/hr.png" },
  CUB: { name: "Cuba", flag: "https://flagcdn.com/w80/cu.png" },
  CUW: { name: "Curaçao", flag: "https://flagcdn.com/w80/cw.png" },
  CYP: { name: "Cyprus", flag: "https://flagcdn.com/w80/cy.png" },
  CZE: { name: "Czech Republic", flag: "https://flagcdn.com/w80/cz.png" },
  CIV: { name: "Côte d'Ivoire", flag: "https://flagcdn.com/w80/ci.png" },
  DNK: { name: "Denmark", flag: "https://flagcdn.com/w80/dk.png" },
  DJI: { name: "Djibouti", flag: "https://flagcdn.com/w80/dj.png" },
  DMA: { name: "Dominica", flag: "https://flagcdn.com/w80/dm.png" },
  DOM: { name: "Dominican Republic", flag: "https://flagcdn.com/w80/do.png" },
  ECU: { name: "Ecuador", flag: "https://flagcdn.com/w80/ec.png" },
  EGY: { name: "Egypt", flag: "https://flagcdn.com/w80/eg.png" },
  SLV: { name: "El Salvador", flag: "https://flagcdn.com/w80/sv.png" },
  EST: { name: "Estonia", flag: "https://flagcdn.com/w80/ee.png" },
  SWZ: { name: "Eswatini", flag: "https://flagcdn.com/w80/sz.png" },
  FIN: { name: "Finland", flag: "https://flagcdn.com/w80/fi.png" },
  FRA: { name: "France", flag: "https://flagcdn.com/w80/fr.png" },
  GUF: { name: "French Guiana", flag: "https://flagcdn.com/w80/gf.png" },
  PYF: { name: "French Polynesia", flag: "https://flagcdn.com/w80/pf.png" },
  GAB: { name: "Gabon", flag: "https://flagcdn.com/w80/ga.png" },
  GMB: { name: "Gambia", flag: "https://flagcdn.com/w80/gm.png" },
  GEO: { name: "Georgia", flag: "https://flagcdn.com/w80/ge.png" },
  DEU: { name: "Germany", flag: "https://flagcdn.com/w80/de.png" },
  GHA: { name: "Ghana", flag: "https://flagcdn.com/w80/gh.png" },
  GIB: { name: "Gibraltar", flag: "https://flagcdn.com/w80/gi.png" },
  GRC: { name: "Greece", flag: "https://flagcdn.com/w80/gr.png" },
  GRL: { name: "Greenland", flag: "https://flagcdn.com/w80/gl.png" },
  GTM: { name: "Guatemala", flag: "https://flagcdn.com/w80/gt.png" },
  GUY: { name: "Guyana", flag: "https://flagcdn.com/w80/gy.png" },
  HTI: { name: "Haiti", flag: "https://flagcdn.com/w80/ht.png" },
  HND: { name: "Honduras", flag: "https://flagcdn.com/w80/hn.png" },
  HKG: { name: "Hong Kong", flag: "https://flagcdn.com/w80/hk.png" },
  HUN: { name: "Hungary", flag: "https://flagcdn.com/w80/hu.png" },
  ISL: { name: "Iceland", flag: "https://flagcdn.com/w80/is.png" },
  IND: { name: "India", flag: "https://flagcdn.com/w80/in.png" },
  IDN: { name: "Indonesia", flag: "https://flagcdn.com/w80/id.png" },
  IRN: { name: "Iran", flag: "https://flagcdn.com/w80/ir.png" },
  IRQ: { name: "Iraq", flag: "https://flagcdn.com/w80/iq.png" },
  IRL: { name: "Ireland", flag: "https://flagcdn.com/w80/ie.png" },
  ISR: { name: "Israel", flag: "https://flagcdn.com/w80/il.png" },
  ITA: { name: "Italy", flag: "https://flagcdn.com/w80/it.png" },
  JAM: { name: "Jamaica", flag: "https://flagcdn.com/w80/jm.png" },
  JPN: { name: "Japan", flag: "https://flagcdn.com/w80/jp.png" },
  JOR: { name: "Jordan", flag: "https://flagcdn.com/w80/jo.png" },
  KAZ: { name: "Kazakhstan", flag: "https://flagcdn.com/w80/kz.png" },
  KEN: { name: "Kenya", flag: "https://flagcdn.com/w80/ke.png" },
  XKX: { name: "Kosovo", flag: "https://flagcdn.com/w80/xk.png" },
  KWT: { name: "Kuwait", flag: "https://flagcdn.com/w80/kw.png" },
  LVA: { name: "Latvia", flag: "https://flagcdn.com/w80/lv.png" },
  LBN: { name: "Lebanon", flag: "https://flagcdn.com/w80/lb.png" },
  LSO: { name: "Lesotho", flag: "https://flagcdn.com/w80/ls.png" },
  LBR: { name: "Liberia", flag: "https://flagcdn.com/w80/lr.png" },
  LBY: { name: "Libya", flag: "https://flagcdn.com/w80/ly.png" },
  LIE: { name: "Liechtenstein", flag: "https://flagcdn.com/w80/li.png" },
  LTU: { name: "Lithuania", flag: "https://flagcdn.com/w80/lt.png" },
  LUX: { name: "Luxembourg", flag: "https://flagcdn.com/w80/lu.png" },
  MAC: { name: "Macao", flag: "https://flagcdn.com/w80/mo.png" },
  MDG: { name: "Madagascar", flag: "https://flagcdn.com/w80/mg.png" },
  MYS: { name: "Malaysia", flag: "https://flagcdn.com/w80/my.png" },
  MDV: { name: "Maldives", flag: "https://flagcdn.com/w80/mv.png" },
  MLI: { name: "Mali", flag: "https://flagcdn.com/w80/ml.png" },
  MLT: { name: "Malta", flag: "https://flagcdn.com/w80/mt.png" },
  MUS: { name: "Mauritius", flag: "https://flagcdn.com/w80/mu.png" },
  MEX: { name: "Mexico", flag: "https://flagcdn.com/w80/mx.png" },
  MDA: { name: "Moldova", flag: "https://flagcdn.com/w80/md.png" },
  MCO: { name: "Monaco", flag: "https://flagcdn.com/w80/mc.png" },
  MNG: { name: "Mongolia", flag: "https://flagcdn.com/w80/mn.png" },
  MNE: { name: "Montenegro", flag: "https://flagcdn.com/w80/me.png" },
  MAR: { name: "Morocco", flag: "https://flagcdn.com/w80/ma.png" },
  MOZ: { name: "Mozambique", flag: "https://flagcdn.com/w80/mz.png" },
  MMR: { name: "Myanmar", flag: "https://flagcdn.com/w80/mm.png" },
  NAM: { name: "Namibia", flag: "https://flagcdn.com/w80/na.png" },
  NPL: { name: "Nepal", flag: "https://flagcdn.com/w80/np.png" },
  NLD: { name: "Netherlands", flag: "https://flagcdn.com/w80/nl.png" },
  NZL: { name: "New Zealand", flag: "https://flagcdn.com/w80/nz.png" },
  NOR: { name: "Norway", flag: "https://flagcdn.com/w80/no.png" },
  OMN: { name: "Oman", flag: "https://flagcdn.com/w80/om.png" },
  PAK: { name: "Pakistan", flag: "https://flagcdn.com/w80/pk.png" },
  PSE: { name: "Palestine", flag: "https://flagcdn.com/w80/ps.png" },
  PAN: { name: "Panama", flag: "https://flagcdn.com/w80/pa.png" },
  PNG: { name: "Papua New Guinea", flag: "https://flagcdn.com/w80/pg.png" },
  PRY: { name: "Paraguay", flag: "https://flagcdn.com/w80/py.png" },
  PER: { name: "Peru", flag: "https://flagcdn.com/w80/pe.png" },
  PHL: { name: "Philippines", flag: "https://flagcdn.com/w80/ph.png" },
  POL: { name: "Poland", flag: "https://flagcdn.com/w80/pl.png" },
  PRT: { name: "Portugal", flag: "https://flagcdn.com/w80/pt.png" },
  PRI: { name: "Puerto Rico", flag: "https://flagcdn.com/w80/pr.png" },
  QAT: { name: "Qatar", flag: "https://flagcdn.com/w80/qa.png" },
  ROU: { name: "Romania", flag: "https://flagcdn.com/w80/ro.png" },
  RUS: { name: "Russia", flag: "https://flagcdn.com/w80/ru.png" },
  SAU: { name: "Saudi Arabia", flag: "https://flagcdn.com/w80/sa.png" },
  SRB: { name: "Serbia", flag: "https://flagcdn.com/w80/rs.png" },
  SYC: { name: "Seychelles", flag: "https://flagcdn.com/w80/sc.png" },
  SGP: { name: "Singapore", flag: "https://flagcdn.com/w80/sg.png" },
  SVK: { name: "Slovakia", flag: "https://flagcdn.com/w80/sk.png" },
  SVN: { name: "Slovenia", flag: "https://flagcdn.com/w80/si.png" },
  ZAF: { name: "South Africa", flag: "https://flagcdn.com/w80/za.png" },
  KOR: { name: "South Korea", flag: "https://flagcdn.com/w80/kr.png" },
  ESP: { name: "Spain", flag: "https://flagcdn.com/w80/es.png" },
  LKA: { name: "Sri Lanka", flag: "https://flagcdn.com/w80/lk.png" },
  SWE: { name: "Sweden", flag: "https://flagcdn.com/w80/se.png" },
  CHE: { name: "Switzerland", flag: "https://flagcdn.com/w80/ch.png" },
  SYR: { name: "Syria", flag: "https://flagcdn.com/w80/sy.png" },
  TWN: { name: "Taiwan", flag: "https://flagcdn.com/w80/tw.png" },
  TJK: { name: "Tajikistan", flag: "https://flagcdn.com/w80/tj.png" },
  TZA: { name: "Tanzania", flag: "https://flagcdn.com/w80/tz.png" },
  THA: { name: "Thailand", flag: "https://flagcdn.com/w80/th.png" },
  TUR: { name: "Turkey", flag: "https://flagcdn.com/w80/tr.png" },
  UKR: { name: "Ukraine", flag: "https://flagcdn.com/w80/ua.png" },
  ARE: { name: "United Arab Emirates", flag: "https://flagcdn.com/w80/ae.png" },
  GBR: { name: "United Kingdom", flag: "https://flagcdn.com/w80/gb.png" },
  USA: { name: "United States", flag: "https://flagcdn.com/w80/us.png" },
  URY: { name: "Uruguay", flag: "https://flagcdn.com/w80/uy.png" },
  UZB: { name: "Uzbekistan", flag: "https://flagcdn.com/w80/uz.png" },
  VEN: { name: "Venezuela", flag: "https://flagcdn.com/w80/ve.png" },
  VNM: { name: "Vietnam", flag: "https://flagcdn.com/w80/vn.png" },
  ZMB: { name: "Zambia", flag: "https://flagcdn.com/w80/zm.png" },
  ZWE: { name: "Zimbabwe", flag: "https://flagcdn.com/w80/zw.png" },
  ALA: { name: "Åland Islands", flag: "https://flagcdn.com/w80/ax.png" },
};
